import React, { useEffect, useState } from "react";
import useLocales from "../../../../hooks/useLocales";
import { MdAdd } from "react-icons/md";
import LangModal from "../setting/Language/Modal/LangModal";
import { useStateContext } from "../../../../contexts/ThemeContext";
import { toast } from "react-hot-toast";
import httpRequest from "../../../../axios/index";
import useSettings from "../../../../hooks/useSettings";

const PageLanguage = ({ addedLanguages, languagesShow }) => {
  const { translate } = useLocales();
  const { setActiveSettingSubNav } = useStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMediumOrSmallScreen, setIsMediumOrSmallScreen] = useState(false);

  const handleAddLanguageButtonClick = (event) => {
    event.preventDefault();
    setIsModalOpen(true);
  };
  const { themeDirection } = useSettings();

  useEffect(() => {
    setActiveSettingSubNav("language");
    return () => {
      setActiveSettingSubNav(null);
    };
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMediumOrSmallScreen(window.innerWidth < 1070);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const handleLanguageRemove = async (languageId) => {
    try {
      const url = `/api/user/deletelanguage/${languageId}/${user?.userid}`;
      const response = await httpRequest.delete(url);
      const status = response?.data?.status;
      if (status === "success") {
        languagesShow();
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <div className="w-full bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] mt-10 md:mb-[9px]">
        <div
          className={`flex justify-between items-center ${
            themeDirection === "rtl" ? "flex-row-reverse" : ""
          }`}
          style={{ width: "66%" }}
        >
          <p className="text-small1_bold dark:text-color_v1_dark lg:text-body_copy1 mb-0 lg:mb-0 mr-auto">
            {translate("language_setting.added_languge")}
          </p>
          {!isMediumOrSmallScreen && (
            <button
              onClick={handleAddLanguageButtonClick}
              className="flex items-center rounded-full cursor-pointer text-main_color text-small3_b mt-0"
            >
              <MdAdd className="text-main_color text-gray-50 lg:text-xl text-lg" />
              {translate("language_setting.more_lang_cap")}
            </button>
          )}
        </div>

        <div className="flex flex-col py-2">
          <div className="flex mt-1 gap-2 flex-col lg:flex-row lg:flex-wrap">
            <div className="flex items-center gap-2 relative">
              <div className="dark:border-color_dark dark:text-color_v1_dark bg-transparent py-[5px] lg:py-[8px] px-[5px] border border-light_bg_v2 text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none pr-10 block w-full md:w-full lg:w-[250px]">
                {translate("language_setting.english_default")}
              </div>
            </div>
            {addedLanguages?.map((language, index) => (
              <div key={index} className="flex items-center gap-2 relative">
                <div className="dark:border-color_dark focus:dark:border-font_color dark:text-color_v1_dark bg-transparent py-[5px] lg:py-[8px] px-[5px] border border-light_bg_v2 text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none pr-10 block w-full md:w-full lg:w-[250px]">
                  {language?.label}
                </div>
                <button
                  className="absolute inset-y-0 right-0 px-2 text-red-500 focus:outline-none"
                  onClick={() => {
                    handleLanguageRemove(language?._id);
                  }}
                >
                  &#x2715;
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <LangModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        languagesShow={languagesShow}
      />
      {isMediumOrSmallScreen && (
        <button
          onClick={handleAddLanguageButtonClick}
          className="flex items-center rounded-full cursor-pointer text-main_color text-small3_b "
        >
          <MdAdd className="text-main_color text-gray-50 lg:text-xl text-lg" />
          {translate("language_setting.more_lang_cap")}
        </button>
      )}
    </>
  );
};

export default PageLanguage;
